import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireExtractFiles } from "../node_modules/.pnpm/extract-files@11.0.0/node_modules/extract-files/public/extractFiles.js";
var extractFilesExports = /* @__PURE__ */ requireExtractFiles();
const extractFiles = /* @__PURE__ */ getDefaultExportFromCjs(extractFilesExports);
export {
  extractFiles as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmFjdEZpbGVzLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OzsifQ==
